// Project images
import DAT from './assets/projectimgs/datool.png';
import UFPL from './assets/projectimgs/UFPL.png';
import IT from './assets/projectimgs/it.ufl.edu.png';
import M1 from './assets/projectimgs/mayo1.png';
import Commencement from './assets/projectimgs/commencement.png';

// Other images
import Me from './assets/me.jpg';

//Showcase
import FullMayo from './assets/projectimgs/showcase-images/full-pagemayo.png'
import MayoNav from './assets/projectimgs/showcase-images/mayo-nav.png'
import MayoNavRe from './assets/projectimgs/showcase-images/mayo-nav-re-1.png'
import MayoNavRe2 from './assets/projectimgs/showcase-images/mayo-nav-re-2.png'
import MayoNavRe3 from './assets/projectimgs/showcase-images/mayo-nav-re-3.png'
import MayoColorTile from './assets/projectimgs/showcase-images/mayo-color-tile.png'
import MayoColorTileRe from './assets/projectimgs/showcase-images/mayo-color-tile-re.png'
import MayoFilter from './assets/projectimgs/showcase-images/mayo-filterc.png'
import MayoFilter1 from './assets/projectimgs/showcase-images/mayo-filterc1.png'
import MayoFilter2 from './assets/projectimgs/showcase-images/mayo-filter2.png'

export const archive = [
  {
    year: '2025',
    projectName: 'Mayo Clinic UX/UI Study',
    madeAt: 'Mayo Clinic',
    builtWith: ['Figma', 'Google Analytics', 'HTML', 'CSS', 'JavaScript'],
    link: 'showcase/mayo-clinic-ux',
    linkTitle: 'Showcase'
  },
  {
    year: '2025',
    projectName: 'Domain Analysis Tool',
    madeAt: 'University of Florida',
    builtWith: ['Next.js', 'TypeScript', 'Postman', 'Google Analytics', 'Express', 'MySQL', 'Docker'],
    link: 'https://github.com/jlayog/domain-analysis-tool/',
    linkTitle: 'Github Link'
  },
  {
    year: '2024',
    projectName: 'TeamDynamix System Integration',
    madeAt: 'University of Florida',
    builtWith: ['WordPress', 'PHP', 'Postman', 'TeamDynamix API'],
    link: 'https://www.teamdynamix.com',
    linkTitle: 'TeamDynamix'
  },
  {
    year: '2024',
    projectName: 'IT Redesign at UF',
    madeAt: 'University of Florida',
    builtWith: ['WordPress', 'TerminalFour', 'HTML', 'CSS', 'JavaScript', 'SlickJS', 'Bootstrap 5'],
    link: 'https://it.ufl.edu',
    linkTitle: 'University of Florida Information Technology'
  },
  {
    year: '2023',
    projectName: 'Mercury Pattern Library',
    madeAt: 'University of Florida',
    builtWith: ['WordPress', 'TerminalFour', 'HTML', 'CSS', 'JavaScript', 'SlickJS', 'Bootstrap 5'],
    link: 'https://webservices.it.ufl.edu/mercury-theme/',
    linkTitle: 'UF Mercury Pattern Library'
  },
  {
    year: '2023',
    projectName: 'PolicyHub',
    madeAt: 'University of Florida',
    builtWith: ['WordPress', 'PHP', 'HTML', 'CSS', 'JavaScript'],
    link: 'https://policy.ufl.edu',
    linkTitle: 'https://policy.ufl.edu'
  },
  {
    year: '2023',
    projectName: 'LISTSERV Page Template',
    madeAt: 'University of Florida',
    builtWith: ['WordPress', 'PHP', 'HTML', 'CSS', 'JavaScript'],
    link: 'https://github.com/jlayog/listserv-form-page-template',
    linkTitle: 'Github'
  },
  {
    year: '2023',
    projectName: 'Hamilton Center',
    madeAt: 'University of Florida',
    builtWith: ['HTML', 'CSS', 'JavaScript', 'TerminalFour (CMS)'],
    link: 'https://hamilton.center.ufl.edu',
    linkTitle: 'hamilton.center.ufl.edu'
  },
  {
    year: '2022',
    projectName: 'President Search',
    madeAt: 'University of Florida',
    builtWith: ['WordPress', 'PHP', 'HTML', 'CSS', 'JavaScript'],
    link: 'https://president.ufl.edu',
    linkTitle: 'president.ufl.edu',
  },
  {
    year: '2022',
    projectName: 'Board of Trustees',
    madeAt: 'University of Florida',
    builtWith: ['HTML', 'CSS', 'JavaScript', 'TerminalFour (CMS)'],
    link: 'https://trustees.ufl.edu',
    linkTitle: 'trustees.ufl.edu',
  },
  {
    year: '2022',
    projectName: 'Academic Technology Site Migration',
    madeAt: 'University of Florida',
    builtWith: ['HTML', 'CSS', 'JavaScript', 'TerminalFour (CMS)'],
    link: 'https://at.ufl.edu',
    linkTitle: 'at.ufl.edu',
  },
  {
    year: '2021',
    projectName: 'Technology Support Services',
    madeAt: 'University of Florida',
    builtWith: ['HTML', 'CSS', 'JavaScript', 'TerminalFour (CMS)'],
    link: 'https://tss.it.ufl.edu',
    linkTitle: 'tss.it.ufl.edu',
  },
  {
    year: '2021',
    projectName: 'Enterprise Systems Site Migration',
    madeAt: 'University of Florida',
    builtWith: ['HTML', 'CSS', 'JavaScript', 'TerminalFour (CMS)'],
    link: '',
    linkTitle: '',
  },
  {
    year: '2021',
    projectName: 'GrammarCruncher',
    madeAt: 'University of Florida',
    builtWith: ['React', 'SCSS', 'JSX', 'PHP'],
    link: 'https://languages.ufl.edu/people/faculty-alpha/will-hasty/german-grammar-cruncher/',
    linkTitle: 'GrammarCruncher',
  },
  {
    year: '2021',
    projectName: 'Faculty Senate',
    madeAt: 'University of Florida',
    builtWith: ['HTML', 'CSS', 'JavaScript', 'TerminalFour (CMS)'],
    link: 'https://senate.ufl.edu',
    linkTitle: 'senate.ufl.edu',
  },
  {
    year: '2020',
    projectName: 'Research Computing',
    madeAt: 'University of Florida',
    builtWith: ['HTML', 'CSS', 'JavaScript', 'TerminalFour (CMS)'],
    link: 'https://rc.ufl.edu',
    linkTitle: 'rc.ufl.edu',
  },
  {
    year: '2020',
    projectName: 'UF Directory',
    madeAt: 'University of Florida',
    builtWith: ['HTML', 'CSS', 'PHP', 'JavaScript'],
    link: 'https://directory.ufl.edu',
    linkTitle: 'https://directory.ufl.edu',
  },
  {
    year: '2020',
    projectName: 'Commencement at UF',
    madeAt: 'University of Florida',
    builtWith: ['HTML', 'CSS', 'JavaScript', 'TerminalFour (CMS)'],
    link: 'https://commencement.ufl.edu',
    linkTitle: 'commencement.ufl.edu',
  },
];

// datalist.js
export const experienceCardsData = [
  {
    dateRange: 'March 2025 — Present',
    position: 'UX/UI Engineer',
    organization: 'Mayo Clinic',
    organizationLink: 'https://college.mayo.edu',
    description:
      'Developed components for core brand standards and guidelines, ensuring consistency across digital platforms. Collaborated with cross-functional teams to create user-centric designs that enhance the overall user experience. Utilized tools such as Figma for design and prototyping, and implemented designs using HTML, CSS, and JavaScript.',
    tags: ['Figma', 'JavaScript', 'CSS', 'HTML5'],
  },
  {
    dateRange: 'Nov 2023 — Present',
    position: 'Mid-level Frontend Developer',
    organization: 'University of Florida',
    organizationLink: 'https://ufl.edu',
    description:
      'Lead in the development and refinement of accessible, compliant web solutions, adhering to established brand guidelines and technology frameworks. Oversee projects from concept through to deployment, focusing on functionality and alignment with organizational goals. Provide mentorship to junior developers, emphasizing collaborative development and adherence to best practices.',
    tags: ['React', 'WordPress', 'JavaScript', 'PHP', 'CSS', 'HTML5', 'TerminalFour (CMS)'],
  },
  {
    dateRange: 'May 2020 — Nov 2023',
    position: 'Frontend Developer',
    organization: 'University of Florida',
    organizationLink: 'https://ufl.edu',
    description:
      'Developed user-friendly interfaces, ensured web accessibility, and utilized the latest technologies to provide an engaging and intuitive online experience. Working in concert with cross-functional teams, designing concepts into functional, efficient websites and applications that supported our institution\'s educational goals.',
    tags: ['React', 'WordPress', 'JavaScript', 'PHP', 'CSS', 'HTML5', 'TerminalFour (CMS)'],
  },
  {
    dateRange: "Sep 2019 — May 2020",
    position: "Web Designer",
    organization: "University of Florida",
    organizationLink: "https://ufl.edu",
    description: "Designed ADA-compliant websites and applications, collaborated with cross-functional teams, and kept abreast of the latest design trends to enhance our institution's digital presence and support our mission of delivering a top 5 university education.",
    tags: ["Figma", "Photoshop", "CSS", "HTML", "JavaScript", "PHP", "TerminalFour (CMS)"]
  },
  {
    dateRange: "Feb — Sep 2019",
    position: "Web Technician",
    organization: "University of Florida",
    organizationLink: "https://ufl.edu",
    description: "Maintained and enhanced our organization's online presence. My duties involve troubleshooting technical issues, updating website content, assisting in the development and implementation of site improvements, and ensuring optimal website functionality.",
    tags: ["CSS", "HTML", "JavaScript", "TerminalFour (CMS)"]
  },
  // More experience cards...
];


export const projects = [
  {
    link: 'showcase/mayo-clinic-ux',
    slug: 'mayo-clinic-ux',
    externalLink: 'https://college.mayo.edu/',
    title: 'UX/UI Write-up for Mayo Clinic',
    role: 'UX/UI Designer',
    timeline: 'Mar 2025 — Present',
    description: 'Crafted a comprehensive case study detailing the UX/UI design process for the Mayo Clinic College of Medicine and Science website redesign. The write-up covers research, wireframing, prototyping, user testing, and final implementation, highlighting the challenges faced and solutions implemented to enhance user experience and accessibility.',
    imgSrc: M1,
    tags: ['Figma', 'Google Analytics', 'HTML', 'CSS', 'JavaScript'],
  },
  {
    link: 'https://github.com/jlayog/domain-analysis-tool/',
    title: 'Domain Analysis Tool',
    role: 'Full Stack Developer',
    timeline: 'Jun 2023 — Nov 2023',
    description: 'Developed a Next.js, Node.js, and MySQL application that scrapes website domains using Google Analytics for site migration projects. Users can preview pages, add migration notes, and track progress. Features OAuth2.0 authentication for secure access and Docker containerization for easy deployment by infrastructure teams.',
    imgSrc: DAT,
    tags: ['Next.js', 'TypeScript', 'Postman', 'Google Analytics', 'Express', 'MySQL', 'Docker'],
  },
  {
    link: 'https://webservices.it.ufl.edu/mercury-theme/',
    title: 'Mercury Pattern Library',
    role: 'Frontend Developer',
    timeline: 'Feb 2022 — Aug 2022',
    description: 'Engineered pattern library components to modernize the brand theme for a public university, enhancing component reusability and consistency across digital platforms. Complete with well-documented components and guidelines on usage scenarios.',
    imgSrc: UFPL,
    tags: ['WordPress', 'TerminalFour', 'HTML', 'CSS', 'JavaScript', 'SlickJS', 'Bootstrap 5'],
  },
  {
    link: 'https://it.ufl.edu',
    title: 'IT Redesign at UF',
    role: 'Web Designer',
    timeline: 'Sep 2019 — May 2020',
    description: "Collaborated with a team of developers and designers to redesign the University of Florida's IT website, a hub for IT services, resources, and news. The project involved a complete overhaul of the site's design and functionality.",
    imgSrc: IT,
    tags: ["HTML", "CSS", "jQuery", "JavaScript", "TerminalFour (CMS)"],
  },
  {
    link: 'https://commencement.ufl.edu',
    title: 'Commencement at UF',
    role: 'Frontend Developer',
    timeline: '2020 — 2021',
    description: "Led the development of the University of Florida's Commencement Website, a go-to resource for students and families seeking information on graduation ceremonies, times, and other related matters.",
    imgSrc: Commencement,
    tags: ["HTML", "CSS", "jQuery", "JavaScript", "TerminalFour (CMS)"]
  },
];

export const messages = [
  "Hi, I am Jerel Layog. I am a Frontend Web Developer.",
  "I love creating software and web apps.",
  "Looking to hire?",
  "Check out my work."
];

// Showcase data - detailed project write-ups
export const showcaseProjects = [
  {
    id: 'mayo-clinic-ux',
    title: 'Mayo Clinic College Website Redesign',
    slug: 'mayo-clinic-ux',
    subtitle: 'Comprehensive UX/UI Design Write-Up',
    date: 'March 2025',
    tags: ['Figma', 'UX Research', 'Accessibility', 'User Testing'],
    sections: [
      {
        type: 'image',
        src: FullMayo,
        alt: 'Mayo Clinic College Website Homepage',
        caption: 'The Mayo Clinic College homepage'
      },
      {
        type: 'text',
        heading: 'Project Overview',
        content: 'The Mayo Clinic College of Medicine and Science required a quiet, subtle UX/UI transformation. Many of the existing components were built without accessibility or users in mind. This project involved researching user needs, designing intuitive interfaces, and implementing accessible solutions that serve students, faculty, and prospective applicants.'
      },
      {
        type: 'text',
        heading: 'Navigation',
        content: 'The navigation dropdowns contain a larger amount of content than typical navigation elements. There is tension between providing comprehensive information versus maintaining clear navigational structure. Key findings revealed that users struggled with finding program information and the application process was unclear.'
      },
      {
        type: 'image',
        src: MayoNav,
        alt: 'Original Navigation of college.mayo.edu',
        caption: 'Original Navigation of college.mayo.edu'
      },
      {
        type: 'text',
        subheading: 'Concerns & Potential Improvements',
        content: 'Each section of the navigation contained multiple links with descriptive text beneath them. While descriptive text adds informational value, it increases processing time for users. Potential improvements I had thought of were to replace the descriptive text beneath links with tooltips or expandable sections or descriptive numbers to elsewhere on the landing page. Adding more whitespace between sections and using subtle background colors or borders to group related items for chunking. The current hover state only underlines, however, by adding background transitions will make clickable elements more obvious'
      },
      {
        type: 'text',
        subheading: 'Goals & User Needs',
        content: 'Fitts\' Law - the primary goal was to find the right destination efficiently. Law of Proximity - the secondary goal was to gather enough information to make informed decisions.'
      },
      {
        type: 'text',
        subheading: 'Content Streamlining vs. Context Preservation',
        content: 'Balancing the need for concise navigation with the desire to provide context is crucial. The challenge lies in determining which information is essential for quick navigation and which can be relegated to secondary pages or tooltips. My approach was to create multiple iterations, each focusing on different aspects of this balance.'
      },
      {
        type: 'image',
        src: MayoNavRe,
        alt: 'First iteration of the Mayo Clinic College Navigation Redesign',
        caption: 'First iteration of the navigation redesign'
      },
      {
        type: 'text',
        subheading: 'Implementing Hick\'s Law',
        content: 'An iteration completely removing the informational context of the navigational links. Some descriptions felt redundant, while others felt that some part of the description should be incorporated to the link text. Removed promotional component to reduce cognitive load. This iteration focused on minimizing choices to speed up decision-making, adhering to Hick\'s Law.'
      },

      {
        type: 'image',
        src: MayoNavRe3,
        alt: 'Second iteration of the Mayo Clinic College Navigation Redesign',
        caption: 'Second iteration of the navigation redesign'
      },
      {
        type: 'text',
        subheading: 'Balancing Information Architecture & Navigation',
        content: 'The final iteration introduced generous whitespace, clearer grouping, and reinstated a key CTA button for balance. This iteration provided a solution to both audiences (prospective students & current students). '
      },

      {
        type: 'image',
        src: MayoNavRe2,
        alt: 'Third iteration of the Mayo Clinic College Navigation Redesign',
        caption: 'Third iteration of the navigation redesign'
      },
      {
        type: 'text',
        heading: 'Color Tile',
        content: 'This existing component had an odd visual contrast that suggests the two grey cards are part of a set, while the high contrast blue card appears to belong to a different category. This creates a confusion about information architecture (are these equivalent options or is one more important?). Also is the "Contact Us" card necessary if it is so close to the footer which contains the same call-to-action?'
      },
      {
        type: 'image',
        src: MayoColorTile,
        alt: 'Mayo Clinic Tile Cards',
        caption: 'Color Tile Component found on https://college.mayo.edu/about/'
      },
      {
        type: 'text',
        subheading: 'Concerns & Potential Improvements',
        content: 'If the cards serve different purposes, then show through labeling, icons, or text treatements that can display the difference. Across the site, it appears blue is typically reserved for primary actions or key brand moments. Using it on a card dilutes its effectiveness elsewhere. Visual inconsistency creates unnecessary cognitive load - Users will spend mental energy trying to understand why one card is different.'
      },
      {
        type: 'text',
        subheading: 'Von Restorff Effect',
        content: 'Logical, intentional content hierarchy. Information → Information → Action. I decided on uniform cards, where all cards are visually consistent, reserving the brand-blue for CTA elements. This design leverages the Von Restorff Effect, where the distinct "Contact Us" button stands out against the uniform cards, drawing user attention effectively.'
      },
      {
        type: 'image',
        src: MayoColorTileRe,
        alt: 'Redesigned Color Tiles',
        caption: 'Redesigned Color Tile Component'
      },
      {
        type: 'text',
        heading: 'Filterable Cards',
        content: 'This component\'s purpose was to provide users with quick information after searching keywords or clicking select boxes based on location or program. The original component has a cramped content presentation as the metadeta elements (type, duration, school, specialty) lack breathing room. There is poor visual hierarchy. Metadata also held equal weight, making it hard to prioritize information.'
      },
      {
        type: 'image',
        src: MayoFilter,
        alt: 'A filtered result card with information displayed on it in a single line',
        caption: 'Original filtered cards component'
      },
      {
        type: 'text',
        subheading: 'Concerns & Potential Improvements',
        content: 'The lack of visual grouping makes the information harder to process. Card boundaries are poorly defined, making an unclear separation of cards. Adding color-coded badges/tags for each location for quick scanning. Could add brief program description/application deadlines for each program.'
      },
      {
        type: 'text',
        subheading: 'Chunking & Visual Hierarchy',
        content: 'By chunking content, grouping the metadata in a 2x2 format improves user scannability. Location tag added, making programs immediately more distinguishable. The redesign introduces clear card boundaries with shadows and spacing, enhancing visual separation. The program title is emphasized with larger, bold text, while metadata is presented in a smaller font size, establishing a clear hierarchy of information.'
      },
      {
        type: 'image',
        src: MayoFilter1,
        alt: 'First iteration of the redesigned Filterable Cards Component',
        caption: 'First iteration of the redesigned filterable cards component'
      },
      {
        type: 'image',
        src: MayoFilter2,
        alt: 'Second iteration of the redesigned Filterable Cards Component',
        caption: 'Second iteration of the redesigned filterable cards component'
      },
      {
        type: 'links',
        links: [
          { url: 'https://college.mayo.edu', text: 'Visit Live Site' },
        ]
      }
    ]
  },
  // Add more showcase projects here
];

// --- PERSONA THEME DATA ---
export const userData = {
  name: "JEREL LAYOG",
  title: "UX/UI ENGINEER & FRONTEND DEV",
  profileImage: Me,
  about: "Back in 2017, I attended my first hackathon and wrote my first line of python for a text adventure game. It was love at first type. Since then, I've been learning and building projects in my free time, and have had the privilege of working with some amazing people.\n\nI'm currently a UX/UI Engineer at Mayo Clinic and a Mid-level Frontend Developer at the University of Florida working with cross-functional teams and clients to build and maintain the university's apps and web presence.\n\nWhen I have free time, I love exploring places and being a foodie. I also enjoy playing video games, digital art, and photography.",
  skills: [
      { category: "Languages", items: ["HTML5", "CSS", "JavaScript", "TypeScript", "Python", "PHP"] },
      { category: "Frameworks & Libs", items: ["React.js", "Next.js", "Tailwind CSS", "Bootstrap 5", "jQuery", "Express"] },
      { category: "Tools", items: ["Figma", "Photoshop", "Git", "Docker", "Postman", "WordPress", "Google Analytics"] }
  ],
  
  // Dynamically pull and map from your existing arrays above
  experience: experienceCardsData.map(exp => ({
      title: exp.position,
      company: exp.organization,
      link: exp.organizationLink,
      date: exp.dateRange,
      desc: exp.description
  })),

  projects: projects.map(proj => ({
      name: proj.title,
      image: proj.imgSrc,
      tags: proj.tags,
      desc: proj.description,
      link: proj.link,
      slug: proj.slug,
      externalLink: proj.externalLink || null,
      role: proj.role,
      timeline: proj.timeline,
  })),

  archive: archive.map(item => ({
      year: item.year,
      title: item.projectName,
      company: item.madeAt,
      tags: item.builtWith,
      link: item.link 
  }))
};